<template>
  <v-container>
    <v-row>
      <v-col
        v-for="vendor in vendors"
        :key="vendor.id"
        class="vendor-col"
        xs="12"
        sm="6"
        md="4"
        lg="3"
        xl="2"
      >
        <v-card class="vendor-card">
          <router-link
            class="vendor-link"
            :to="{
              name: 'vendor',
              params: { vendorId: vendor.id.toString() },
            }"
          >
            <v-img
              v-if="vendor.image"
              :src="vendor.image"
              class="vendor-image"
            />
            <div v-else class="vendor-image"></div>
          </router-link>

          <router-link
            class="vendor-link"
            :to="{
              name: 'vendor',
              params: { vendorId: vendor.id.toString() },
            }"
          >
            <v-card-title class="text-wrap">{{ vendor.name }}</v-card-title>
          </router-link>

          <v-card-actions>
            <v-btn
              :to="{
                name: 'vendor',
                params: { vendorId: vendor.id.toString() },
              }"
              color="primary"
            >
              Se meny
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "VendorList",

  props: {
    vendors: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style stoped>
.vendor-card {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
}

.vendor-card .vendor-image {
  height: 13rem;
}

.vendor-col {
  display: flex;
}

.vendor-card .v-card__title {
  word-break: break-word;
}

.vendor-card a.vendor-link {
  text-decoration: none;
  color: black;
}

.vendor-card a.vendor-link:hover {
  text-decoration: underline;
}
</style>
